module.exports = __webpack_public_path__ + "178d0eadf86c5d7f91bb5a86a81450b0.webp";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/call_your_elites-420.webp
// module id = 205
// module chunks = 0